import { Box, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Logo from '../Header/Logo'

export default function MapHeader(props) {
    const name = props.name
    return (
        <Box spacing={2} sx={{ margin: "16px 16px 0 16px", justifyContent: "space-between", alignItems: "center"  }} display="flex" >
            <Logo name={name} />
            <Link to="/scenarios" style={{ color: "black" }} >
                <Tooltip title="Return to scenarios" placement="right">
                    <ArrowBackIcon sx={{ "&:hover": { color: "grey.main" } }} />
                </Tooltip>
            </Link>
        </Box>
    )
}